import { Modal, ModalBody } from "reactstrap";
import TrackAddModal from "../../components/Modal/TrackAddModal";
import { styles } from "../../pages/MyTracks/styles";
import { ModalButton } from "../../pages/MyTracks/styles";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BatchTrackAddModal from "../../components/Modal/BatchTrackModal";
import AddVersionModal from "../../components/Modal/AddVersionModal";
import CollabModal from "../../components/Modal/CollabModal";
import AddTrackFileModal from "../../components/Modal/AddTrackFileModal";
import { TrackDeleteConfirmModal } from "../../components/Modal/TrackDeleteConfirmModal";
import { MyTrackModalGroupProps } from "./type";
import { APP_COLOR } from "../../theme";

export const MyTrackModalGroup: React.FC<MyTrackModalGroupProps> = ({
  pageLoaded,
  handleFetch,
  modal,
  toggle,
  message,
  deleteConfirmModalOpen,
  closeDeleteConfirmModal,
  handleDeleteTrack,
  openCollabsModal,
  handleCloseCollabsModal,
  trackToEdit,
  open,
  handleClose,
  trackToEditUrl,
  openBatchModal,
  openAddVersionModal,
  openAddTrackFileModal,
  setIsUploading,
  setUploadingFilesDetailsList,
  setUploadingCardsStatusList,
}) => {
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} centered keyboard={false}>
        <ModalBody style={styles.postMessageModal}>
          <IconButton onClick={toggle} style={styles.postMessageModalIcon}>
            <CloseIcon style={{ color: APP_COLOR }} />
          </IconButton>
          <CheckCircleIcon style={{ fontSize: 90, marginBottom: 10 }} />
          <Box style={{ fontSize: 20, marginBottom: 10 }}>{message}</Box>
          <ModalButton
            size="small"
            variant="contained"
            disableFocusRipple
            onClick={toggle}
          >
            Dismiss
          </ModalButton>
        </ModalBody>
      </Modal>
      <TrackDeleteConfirmModal
        deleteConfirmModalOpen={deleteConfirmModalOpen}
        closeDeleteConfirmModal={closeDeleteConfirmModal}
        handleDeleteTrack={handleDeleteTrack}
      />
      {openCollabsModal && (
        <CollabModal
          openCollabsModal={openCollabsModal}
          handleCloseCollabsModal={handleCloseCollabsModal}
          trackToEdit={trackToEdit}
          handleFetchTrackFiles={handleFetch}
        />
      )}
      {open && (
        <TrackAddModal
          open={open}
          handleClose={handleClose}
          trackToEdit={trackToEdit}
          trackToEditUrl={trackToEditUrl}
        />
      )}
      {openBatchModal && (
        <BatchTrackAddModal
          open={openBatchModal}
          handleClose={handleClose}
          setIsUploading={setIsUploading}
          setUploadingFilesDetailsList={setUploadingFilesDetailsList}
          setUploadingCardsStatusList={setUploadingCardsStatusList}
        />
      )}
      {openAddVersionModal && (
        <AddVersionModal
          open={openAddVersionModal}
          handleClose={handleClose}
          track={trackToEdit}
        />
      )}
      {openAddTrackFileModal && (
        <AddTrackFileModal
          open={openAddTrackFileModal}
          handleClose={handleClose}
          track={trackToEdit}
        />
      )}
    </>
  );
};
